module.exports = __webpack_public_path__ + "static/media/style_defaultimage.88d8d09a.svg";